import AbstractElectronOperatorApplicationPlatform
    from "~/operatorApplication/ts/platform/electron/AbstractElectronOperatorApplicationPlatform";
import AbstractPlatformUpdater from "~/operatorApplication/ts/platform/AbstractPlatformUpdater";
import LatestElectronPlatformUpdater from "~/operatorApplication/ts/platform/electron/LatestElectronPlatformUpdater";


export default class LatestElectronOperatorApplicationPlatform extends AbstractElectronOperatorApplicationPlatform {
    protected createUpdaterInstance(): AbstractPlatformUpdater | null {
        return new LatestElectronPlatformUpdater(this);
    }

}